<template>
  <div>
    <PlaylistDetails />
  </div>
</template>

<script>
// @ is an alias to /src
import PlaylistDetails from '@/components/PlaylistDetails.vue'

export default {
  name: 'playlistdetails',
  components: {
    PlaylistDetails
  }
}
</script>
